<template>
    <rkm-overlay>
        <rkm-layout-body title="Meu perfil">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form ref="Form" @save="handleSave" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/cadastro/usuario-perfil/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {
            this.showExitConfirmation(async () => {

                this.unsetShowExitFormConfirmation()
                this.redirectToDashboard()
            })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.redirectToDashboard()
        },
        redirectToDashboard() {
            this.$router.push({ name: 'dashboard' })
        }
    },
    created() {

        this.setShowExitFormConfirmation()
    }
}
</script>